__turbopack_context__.v({
  "header": "DonationCard-module__ccq4Ja__header",
  "newDonation": "DonationCard-module__ccq4Ja__newDonation",
  "yellow-flash": "DonationCard-module__ccq4Ja__yellow-flash",
});
